import { motion } from "framer-motion";
import Logo from "./Logo";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-obsidian text-editorial pt-20 pb-8 px-6 md:px-10 border-t border-editorial/10">
      <div className="max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-12 gap-8 items-start"
        >
          {/* Brand block */}
          <div className="col-span-12 md:col-span-4">
            <Logo variant="light" size={80} />
            <p className="text-editorial/60 text-sm mt-6 leading-relaxed max-w-xs">
              A boutique developer of residential, commercial and civic architecture — headquartered in Bhubaneswar, Odisha.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="chapter-num text-editorial/40 mb-4">EXPLORE</div>
            <ul className="space-y-2 text-editorial/80">
              <li><a href="#projects" className="link-underline">Projects</a></li>
              <li><a href="#philosophy" className="link-underline">Philosophy</a></li>
              <li><a href="#progress" className="link-underline">Progress</a></li>
              <li><a href="#contact" className="link-underline">Contact</a></li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <div className="chapter-num text-editorial/40 mb-4">STUDIO</div>
            <p className="text-editorial/80 text-sm leading-relaxed">
              <span className="inline-flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-lime_kl shrink-0" />
                <span>MGM Heights, Plot 140/9957,<br />K living · 3rd Floor, Kalinga Nagar,<br />Bhubaneswar 751003, Odisha.</span>
              </span>
            </p>
          </div>

          <div className="col-span-12 md:col-span-3">
            <div className="chapter-num text-editorial/40 mb-4">CONTACT</div>
            <a href="tel:08908101907" className="flex items-center gap-2 text-editorial/90 hover:text-lime_kl transition-colors">
              <Phone className="w-4 h-4 text-lime_kl" /> 089081 01907
            </a>
            <a href="mailto:studio@kliving.in" className="flex items-center gap-2 text-editorial/90 hover:text-lime_kl transition-colors mt-3">
              <Mail className="w-4 h-4 text-lime_kl" /> studio@kliving.in
            </a>
            <Link to="/admin/login" className="chapter-num text-editorial/40 mt-8 inline-block hover:text-lime_kl transition-colors">
              ADMIN LOGIN →
            </Link>
          </div>
        </motion.div>

        <div className="mt-16 border-t border-editorial/10 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 chapter-num text-editorial/40">
          <span>© {new Date().getFullYear()} KLIVING DEVELOPMENTS PVT LTD · ALL RIGHTS RESERVED</span>
          <span className="flex items-center gap-2">
            <span className="text-lime_kl">DEMO 01</span>
            <span className="opacity-40">·</span>
            <Link to="/v2" className="hover:text-lime_kl transition-colors">DEMO 02</Link>
            <span className="opacity-40">·</span>
            <Link to="/v3" className="hover:text-lime_kl transition-colors">DEMO 03</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
